export { fetch } from './src/fetch-service';